import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ISAEFieldAssetOverview from './Overview';
import ISAEFieldAssetDetail from './Detail';

const ISAEConfiguration = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route
        path={`${path}/configuration-settings/:configId`}
        component={ISAEFieldAssetDetail}
      />
      <Route
        path={`${path}/configuration-settings/`}
        component={ISAEFieldAssetDetail}
      />
      <Route component={ISAEFieldAssetOverview} />
    </Switch>
  );
};

export default ISAEConfiguration;
